/**
 * The one text-input treatment (D-515).
 *
 * <b>Eighteen files each declared their own copy of this.</b> Fifteen of them
 * held the identical string; the other three differed on the resting background
 * — `bg-surface-2` with `focus:bg-surface` rather than plain `bg-surface` — and
 * those three look genuinely different on screen from every other form in the
 * app. Nobody chose that; it accumulated, in the same way the thirteen page
 * widths of D-225 accumulated, and for the same reason: a local constant is
 * quicker to write than an import and nothing ever compares two of them.
 *
 * <b>Two names, because there are two questions.</b> Most inputs want the full
 * width of their column and take {@link field}. A few sit in a row that shares
 * space — a level beside a style beside a minimum — and take {@link control},
 * composing their own width on top. They are separate for the reason
 * `ClassRecordView` records at its own former copy: a narrower width layered on
 * `w-full` never applies, because every width utility sits in one
 * `@layer utilities` at equal specificity and `w-full` comes later in the
 * generated stylesheet. The order of names in a class attribute has no say in
 * it.
 *
 * <b>Not a component.</b> A `<Field>` would have to forward every input
 * attribute the app uses — `type`, `min`, `step`, `rows`, `list`, `inputMode`,
 * `autoComplete` — and would still be wrapped in a label at every call site. A
 * string composes with what is already there and changes nothing about how a
 * screen is written.
 */

/** A control that brings its own width. */
export const control =
  'rounded-lg border border-line-2 bg-surface px-3 py-2 text-[13.5px] outline-none focus:border-accent'

/** The same control, filling its column — what most inputs want. */
export const field = `w-full ${control}`
